import React from "react";
import { Route, Routes } from "react-router-dom";
import ErrorBoundary from "../../ErrorBoundary/ErrorBoundary";

import Certificaciones from "../pages/Index";

export const CertificacionesRoutes = () => {
  return (
    <Routes>
      <Route path="proveedores" errorElement={<ErrorBoundary />}>
        <Route
          path="certificaciones"
          errorElement={<ErrorBoundary />}
          element={<Certificaciones />}
        />
      </Route>
    </Routes>
  );
};
